import script from "./headFoot.vue?vue&type=script&setup=true&lang=js"
export * from "./headFoot.vue?vue&type=script&setup=true&lang=js"

import "./headFoot.vue?vue&type=style&index=0&id=8c911c76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c911c76"]])

export default __exports__